import { Pipe, PipeTransform } from '@angular/core';
import { getSocialIconForUrl } from '../utils/social-util';

@Pipe({
  name: 'socialIcon',
})
export class SocialIconPipe implements PipeTransform {
  transform(url: string | undefined | null, ...args: unknown[]): string {
    return getSocialIconForUrl(url || '');
  }
}
